import React from "react";
import { Grid } from "@mui/material";
import CustomTypography from "../../../widgets/typography";
import Issuer from "./issuer";
import useMessageSourceWithFallback from "../../../../util/message";
import "./styles.scss";
import GridMainLayout from "../../../widgets/grid";
import Logo from "./logo";

const classNameBase = "scd-page-footer";

export default function PageFooter(): React.JSX.Element {
  const { getMessageOrFallback, getMessageWithNamedParamsOrFallback } =
    useMessageSourceWithFallback();
  const year = new Date().getFullYear();

  return (
    <footer className={classNameBase}>
      <Grid className={`${classNameBase}-top`}>
        <GridMainLayout>
          <Grid
            container
            size={{ xs: 12, md: 5, lg: 6 }}
            className={`${classNameBase}-text-container`}
          >
            <CustomTypography variant={"body2"}>
              {getMessageOrFallback(
                "Footer.support",
                "Brauchen Sie Hilfe beim Antrag?",
              )}
            </CustomTypography>
            <CustomTypography variant={"body2"}>
              {getMessageOrFallback(
                "Footer.support-phone",
                "+ 41 44 659 25 57",
              )}
            </CustomTypography>
            <CustomTypography variant={"body2"}>
              {getMessageOrFallback(
                "Footer.support-hours",
                "Montag bis Freitag 8 - 18 Uhr",
              )}
            </CustomTypography>
          </Grid>
        </GridMainLayout>
      </Grid>
      <div className={`${classNameBase}-bottom`}>
        <GridMainLayout
          alignItems={"flex-start"}
          justifyContent={"space-between"}
          spacing={5}
        >
          <Grid
            className={`${classNameBase}-bottom-wrapper`}
            container
            size="grow"
          >
            <Grid container size={{ xs: 3, md: 3, lg: 3 }}>
              <Logo />
            </Grid>
            <Grid container size={{ xs: 9, md: 9, lg: 9 }}>
              <Issuer
                issuer={getMessageWithNamedParamsOrFallback(
                  "Footer.part-one",
                  { year },
                  `Cards, issued by Swisscard AECS GmbH, Neugasse 18, 8810 Horgen | Copyright © ${year}`,
                )}
                legalConditions={{
                  text: getMessageOrFallback(
                    "Footer.legal-conditions",
                    "Legal Conditions and information",
                  ),
                  url: getMessageOrFallback(
                    "Footer.agbLink-url",
                    "https://www.swisscard.ch/de/rechtlichebedingungen-hinweise",
                  ),
                }}
                dataProtection={{
                  text: getMessageOrFallback(
                    "Footer.data-protection",
                    "Data protection",
                  ),
                  url: getMessageOrFallback(
                    "Footer.agbLink-url.data-protection",
                    "https://www.swisscard.ch/de/rechtlichebedingungen-hinweise#datenschutz",
                  ),
                }}
              />
            </Grid>
          </Grid>
        </GridMainLayout>
      </div>
    </footer>
  );
}
